/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { css } from '@emotion/react';
import { Helmet } from 'react-helmet';

import GlobalStyles from './GlobalStyles';

type Props = {};

const DefaultLayout: React.FC<Props> = ({
  children,

  ...props
}) => {
  return (
    <>
      <GlobalStyles />
      <Helmet>
        <link rel="shortcut icon" type="image/svg+xml" href="/favicon.svg" />
      </Helmet>
      <div
        css={css`
          /* stylelint-disable */
          overflow: hidden;
        `}
        {...props}
      >
        {children}
      </div>
    </>
  );
};

export default DefaultLayout;
